export enum ConversationStatus {
  PendingOptIn = 1,
  Active = 2,
  Stopped = 3,
  Created = 4,
  Paused = 5,
}
